var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4091 19.5V21H19.9091V19.5H18.4091Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 16.5V18H15.4091V16.5H13.9091Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 22.5H16.9091V21H15.4091V19.5H13.9091V22.5Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.909 16.5L19.9091 19.5H21.409V16.5H19.909Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.409 19.5H22.9091V22.5H19.9091V21H21.4091L21.409 19.5Z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9091 15V13.5H22.9091V16.5H21.409L21.4091 15H19.9091Z",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4091 15H16.9091V18H15.4091V19.5H18.4091V15Z",
    fill: ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 13.5V15H16.9091V13.5H13.9091Z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90912 16.5H4.90912V19.5H7.90912V16.5Z",
    fill: ""
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 22.5H1.90912V13.5H10.9091V22.5ZM3.40912 21H9.40912V15H3.40912V21Z",
    fill: ""
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9091 4.5H16.9091V7.5H19.9091V4.5Z",
    fill: ""
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 10.5H13.9091V1.5H22.9091V10.5ZM15.4091 9H21.4091V3H15.4091V9Z",
    fill: ""
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90912 4.5H4.90912V7.5H7.90912V4.5Z",
    fill: ""
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 10.5H1.90912V1.5H10.9091V10.5ZM3.40912 9H9.40912V3H3.40912V9Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVcard);
export default __webpack_public_path__ + "static/media/ic-vcard.fe9d9f98c7989023bb18dddbcd71ae3f.svg";
export { ForwardRef as ReactComponent };